'use strict';
var $ = require('../internals/export');
var isRegisteredSymbol = require('../internals/symbol-is-registered');

// `Symbol.isRegisteredSymbol` method
// https://tc39.es/proposal-symbol-predicates/#sec-symbol-isregisteredsymbol
$({ target: 'Symbol', stat: true }, {
  isRegisteredSymbol: isRegisteredSymbol
});



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/esnext.symbol.is-registered-symbol.js
// module id = 1519
// module chunks = 0